/* eslint-disable import/prefer-default-export */
import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import styled from 'styled-components';

const ImageSharp = styled(Img)`
  width: 100%;
  height: 100%;
`;

const QUERY = graphql`
  query {
    outdoor: file(sourceInstanceName: { eq: "images" }, name: { eq: "outdoor" }) {
      childImageSharp {
        fluid(maxWidth: 680) {
          ...GatsbyImageSharpFluid_withWebp_tracedSVG
        }
      }
    }
  }
`;

export const OutdoorImage = () => {
  //
  const { outdoor } = useStaticQuery(QUERY);

  return <ImageSharp fluid={outdoor.childImageSharp.fluid} />;
};
